import htmr from 'htmr';
import { marked } from 'marked';
import styled from 'styled-components';
import { IconEmailLarge, IconOpenInNewSmall } from '@izettle/otto';
import { mapTranslations, ModalBase, ModalSize, Icon, Text, ModalFooter, Button } from '@izettle/react';
import { translations } from '../.tenko/index.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const Centered = /*#__PURE__*/styled.div.withConfig({
  displayName: "email-confirmation-modal__Centered",
  componentId: "zettle__sc-1w05v4f-0"
})(["text-align:center;"]);
const CenterHorizontally = /*#__PURE__*/styled.div.withConfig({
  displayName: "email-confirmation-modal__CenterHorizontally",
  componentId: "zettle__sc-1w05v4f-1"
})(["width:100%;display:flex;justify-content:center;"]);
const ParagraphLargeLineHeight = /*#__PURE__*/styled.p.withConfig({
  displayName: "email-confirmation-modal__ParagraphLargeLineHeight",
  componentId: "zettle__sc-1w05v4f-2"
})(["line-height:32px;"]);
const transformStepParagraph = {
  p: ParagraphLargeLineHeight
};
const TEXT_KEYS = {
  title: "EMAIL_CONFIRMATION_INSTRUCTIONS_MODAL_TITLE",
  brief: "EMAIL_CONFIRMATION_INSTRUCTIONS_MODAL_BRIEF",
  steps: "EMAIL_CONFIRMATION_INSTRUCTIONS_MODAL_STEPS",
  redirectButton: "EMAIL_CONFIRMATION_INSTRUCTIONS_MODAL_REDIRECT_BUTTON",
  closeHint: "EMAIL_CONFIRMATION_INSTRUCTIONS_MODAL_CLOSE_HINT"
};
const localeText = mapTranslations(translations);
const EmailConfirmationModal = _ref => {
  let {
    isVisible,
    locale,
    onClose
  } = _ref;
  const text = localeText(locale);
  const emailSettingsUrl = window.location.hostname.includes("zettle.com") ? "https://www.paypal.com/businessprofile/settings/email" : "https://www.izettle.stage.paypal.com/businessprofile/settings/email";
  const onRedirectButtonClick = () => {
    onClose();
    window.open(emailSettingsUrl, "_blank")?.focus();
  };
  return /*#__PURE__*/jsxs(ModalBase, {
    id: "email-confirmation-instructions",
    isVisible: isVisible,
    onClose: onClose,
    textCloseModal: text(TEXT_KEYS.closeHint),
    size: ModalSize.Medium,
    children: [/*#__PURE__*/jsxs(Centered, {
      children: [/*#__PURE__*/jsx(CenterHorizontally, {
        children: /*#__PURE__*/jsx(Icon, {
          svgIcon: IconEmailLarge,
          block: true
        })
      }), /*#__PURE__*/jsx(Text.Title2, {
        marginTop: "medium",
        children: text(TEXT_KEYS.title)
      })]
    }), /*#__PURE__*/jsx(Text.RegularSecondary, {
      marginTop: "xSmall",
      marginBottom: "none",
      children: htmr(marked(text(TEXT_KEYS.brief)))
    }), /*#__PURE__*/jsx(Text.Regular, {
      marginTop: "medium",
      marginBottom: "none",
      children: htmr(marked(text(TEXT_KEYS.steps)), {
        transform: transformStepParagraph
      })
    }), /*#__PURE__*/jsx(ModalFooter, {
      children: /*#__PURE__*/jsx(Button, {
        onClick: onRedirectButtonClick,
        svgIcon: IconOpenInNewSmall,
        children: text(TEXT_KEYS.redirectButton)
      })
    })]
  });
};

export { EmailConfirmationModal };
//# sourceMappingURL=email-confirmation-modal.js.map
